import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Devices from './Devices';
import DeviceImportData from '../DeviceImportData/DeviceImportData';
import DeviceInfo from './DeviceInfo';
import LogsDevice from './LogsDevice';
import LogsInfoDevice from './LogsInfoDevice';

export default function LayoutDevices() {
    const [activeComponent, setActiveComponent] = useState('Devices');
    const location = useLocation();
    const params = useParams();

    useEffect(() => {
        if (location.pathname.startsWith('/device/')) {
            setActiveComponent('DeviceInfo');
        } else if (location.pathname === '/devices') {
            setActiveComponent('Devices');
        }
    }, [location]);

    return (
        <>
            {activeComponent === 'Devices' && (
                <Devices
                    onButtonClick={() => setActiveComponent('DeviceImportData')}
                    handleLogsClick={() => setActiveComponent('Logs')}
                    deviceInfo={() => setActiveComponent('DeviceInfo')}
                />
            )}
            {activeComponent === 'DeviceImportData' && (
                <DeviceImportData onBackClick={() => setActiveComponent('Devices')} />
            )}
            {activeComponent === 'DeviceInfo' && (
                <DeviceInfo
                    deviceId={params.id}
                    onBackClick={() => setActiveComponent('Devices')}
                    handleInfoLogsClick={() => setActiveComponent('LogsInfoDevice')}
                />
            )}
            {activeComponent === 'Logs' && (
                <LogsDevice onBackClick={() => setActiveComponent('Devices')} />
            )}
            {activeComponent === 'LogsInfoDevice' && (
                <LogsInfoDevice
                    deviceId={params.id}
                    onBackClick={() => setActiveComponent('DeviceInfo')}
                />
            )}
        </>    
    );
}
